import React from 'react';
import { Modal,Button } from 'react-bootstrap'

const ModalDelete = (props) => {
    const { show, close, title, text, deleteFunction } = props;
    return (
        <Modal show={show} onHide={() => close()} centered >
            <Modal.Header className="bg-danger">
                <h3 className="text-white">Eliminar {title}</h3>
            </Modal.Header>
            <Modal.Body>{text}</Modal.Body>
            <Modal.Footer>
                <Button
                    variant="danger"
                    onClick={() => {
                        deleteFunction();
                        close();
                    }}
                >Eliminar</Button>
                <Button onClick={() => close()} variant="secondary">Canelar</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalDelete;